/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Register_TitleInputs */



/**
* | output |
* | --- |
* | "Register New Application" |
*
* @param {Developer_Register_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_register_title = /** @type {((inputs?: Developer_Register_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Register_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer une nouvelle application")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registrar nueva aplicación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Registrar Novo Aplicativo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registra Nuova Applicazione")
	return /** @type {LocalizedString} */ ("Register New Application")
});